export const DriverLoadChargeTypes = {
    addition: 'Addition',
    deduction: 'Deduction',
};
